import {
    Button,
    Grid,
    Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Auth } from 'aws-amplify';
import { host } from "../data";
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    indented: {
        marginLeft: theme.spacing(10),
    },
    content: {
        padding: theme.spacing(2),
    },
    table: {
        minWidth: 650,
        border: "none",
        boxShadow: "none"
    },
    DemoButton: {
    },
}));

export default function DemoInvite({ fetchOrgInformation }) {
    const classes = useStyles();
    const { t, i18n } = useTranslation();
    const handleJoinDemo = () => {
        Auth.currentAuthenticatedUser()
            .then(data => {
                var requestOptions = {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': data.signInUserSession.idToken.jwtToken,
                    },
                };

                fetch(host + '/demoinvite/', requestOptions)
                    .then(results => results.json())
                    .then(data => {
                        if (data.Error === "OK") {
                            alert(t("youHaveBeenAdded"));
                            fetchOrgInformation(t("gracoDemo"), true);
                        }
                        else if (data.Error.includes("User already has access")) {
                            alert(t("youAlreadyHaveAccess"));
                            fetchOrgInformation(t("gracoDemo"), true);
                        }
                    }).catch((error) => {
                        console.log(error)
                    })
            });
    };

    return (
        <Grid container item
            direction='column'
            justify='center'
            alignItems='center'
            className={classes.content}
        >
            <Grid item xs className={classes.content}>
                <Typography>{t("clickButtonBelowToInvite")}</Typography>
            </Grid>
            <Grid item xs className={classes.content}>
                <Button color="primary" variant="contained" onClick={handleJoinDemo}>
                    {t("joinDemoOrganization")}
                </Button>
            </Grid>
        </Grid>
    );
}
